<template>
  <div
    class="d-flex flex-wrap flex-sm-nowrap justify-content-end align-items-center w-100">

    <!-- Cancel -->
    <memlist-button
      class="btn-mobile-half mr-sm-2 w-100 w-sm-auto"
      variant="secondary"
      @click.prevent="$emit('close')">
      {{ cancel_text || $t('COMMON.CLOSE') }}
    </memlist-button>

    <!-- Save -->
    <div v-if="!(hide_primary === true)" class="btn-mobile-half">
      <memlist-button
        v-if="spin"
        class="w-100 w-sm-auto ml-2"
        variant="primary"
        :disabled="disabled || spinning"
        @click.prevent="on_save_clicked">
        <memlist-spinner v-if="spinning" size="sm" class="mr-2"/>
        {{ text }}
      </memlist-button>

      <memlist-button
        v-else
        class="w-100 w-sm-auto"
        variant="primary"
        :disabled="disabled"
        @click.prevent="on_save_clicked">
        {{ text }}
      </memlist-button>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import dayjs from 'dayjs';

import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'RightModalSaveAndCloseButtons',
  components: {

  },
  mixins: [ toasts ],
  props: ['text','disabled','spin','hide_primary','cancel_text'],
  emits: ['clicked', 'close'],
  computed: {
    ...mapGetters([])
  },
  data() {
    return {
      spinning: false
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    stop() {
      const that = this;

      setTimeout(()=>{
        that.spinning = false;
      }, 500);
    },

    on_save_clicked() {
      this.spinning = true;

      this.$emit('clicked');
    }
  }
};
</script>

<style scoped>
/* ≤575 px: each button should take 50 % of the row */
@media (max-width: 575.98px) {
  .btn-mobile-half {
    flex: 0 0 50%;   /* basis 50 %, don’t grow */
    max-width: 50%;  /* caps width */
  }
}

/* ≥576 px (Bootstrap’s sm+) revert to natural size */
@media (min-width: 576px) {
  .btn-mobile-half {
    flex: 0 0 auto;
    max-width: none;
  }
}

</style>
